<div class="w-full mx-auto space-y-6 pb-8">

    <!-- Titre -->
    <h1 class="text-2xl font-bold text-gray-900 text-center">{{ 'vues.qr-code.checkout-form.title' | translate }}</h1>

    <!-- Recherche du visiteur parmi les visites actives -->
    <div class="bg-white rounded-sm shadow-sm border border-gray-200 p-4 space-y-4">
        <p class="text-gray-700 text-center">
            {{ 'vues.qr-code.checkout-form.enter-name' | translate }}
        </p>
        <app-multi-select
            [options]="activeVisitorsLookup()"
            [isMultiselect]="false"
            [minChars]="3"
            [placeholder]="'vues.qr-code.checkout-form.select-name-placeholder' | translate"
            [maxItems]="1"
            [selectedKeys]="selectedVisitorId()"
            (selectedKeysChange)="onVisitorSelectChange($event)">
        </app-multi-select>
    </div>

    <!-- Aucune visite active trouvée -->
    @if (profileNotFound()) {
    <div class="bg-white rounded-sm shadow-sm border border-gray-200 p-4 flex items-start gap-4">
        <div class="w-12 h-12 rounded-full bg-red-500 flex items-center justify-center text-white text-xl shrink-0">
            <i class="fas fa-times"></i>
        </div>
        <div>
            <p class="font-bold text-gray-900">{{ 'vues.qr-code.checkout-form.profile-not-found-title' | translate }}</p>
            <p class="text-sm text-gray-600">{{ 'vues.qr-code.checkout-form.profile-not-found-message' | translate }}</p>
        </div>
    </div>
    }

    <!-- Checkout enregistré (sans feedback) -->
    @if (profileFound()) {
    <div class="bg-white rounded-sm shadow-sm border border-gray-200 p-4 flex items-start gap-4">
        <div class="w-12 h-12 rounded-full bg-green-500 flex items-center justify-center text-white text-xl shrink-0">
            <i class="fas fa-check"></i>
        </div>
        <div>
            <p class="font-bold text-gray-900">{{ 'vues.qr-code.checkout-form.profile-found-title' | translate }}</p>
            <p class="text-sm text-gray-600">
                {{ 'vues.qr-code.checkout-form.profile-found-message' | translate:{name: editingEntity()?.visitor?.fullname ?? ''} }}
            </p>
        </div>
    </div>
    }

    <!-- Feedback + Checkout (si dS_Checkout_Feedbacks activé sur le POS) -->
    @if (showFeedbackForm()) {
    <div class="bg-white rounded-sm shadow-sm border border-gray-200 p-4 space-y-4">
        <p class="text-center text-gray-700">{{ 'vues.qr-code.checkout-form.feedback-question' | translate }}</p>

        <div class="flex justify-center gap-8">
            <div class="cursor-pointer transition hover:scale-110"
                (click)="setFeedbackScore(1)"
                [class.opacity-40]="feedbackScore() !== 1 && feedbackScore() !== undefined">
                <app-bubble-smiley [score]="1" [showAsBubble]="false" [showAsSelected]="feedbackScore() === 1" size="w-16 h-16"></app-bubble-smiley>
            </div>
            <div class="cursor-pointer transition hover:scale-110"
                (click)="setFeedbackScore(2)"
                [class.opacity-40]="feedbackScore() !== 2 && feedbackScore() !== undefined">
                <app-bubble-smiley [score]="2" [showAsBubble]="false" [showAsSelected]="feedbackScore() === 2" size="w-16 h-16"></app-bubble-smiley>
            </div>
            <div class="cursor-pointer transition hover:scale-110"
                (click)="setFeedbackScore(3)"
                [class.opacity-40]="feedbackScore() !== 3 && feedbackScore() !== undefined">
                <app-bubble-smiley [score]="3" [showAsBubble]="false" [showAsSelected]="feedbackScore() === 3" size="w-16 h-16"></app-bubble-smiley>
            </div>
        </div>

        <p class="text-sm text-gray-600">{{ 'vues.qr-code.checkout-form.comments' | translate }}</p>
        <textarea [(ngModel)]="feedbackComment" rows="3"
            class="w-full border border-gray-300 rounded-sm p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"></textarea>
    </div>
    }

    <!-- Actions -->
    <div class="flex flex-col gap-3 pt-2">
        @if (showFeedbackForm()) {
        <button
            class="w-full bg-green-600 hover:bg-green-700 text-white font-semibold py-3 rounded-sm transition"
            (click)="submitCheckout()">
            {{ 'vues.qr-code.checkout-form.submit' | translate }}
        </button>
        }
        <button
            class="w-full bg-red-500 hover:bg-red-600 text-white font-semibold py-3 rounded-sm transition"
            (click)="goHome()">
            {{ 'buttons.cancel' | translate }}
        </button>
    </div>

</div>